/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetPaymentRequestEvidenceRecords200ResponseInnerWarnings
 */
export interface GetPaymentRequestEvidenceRecords200ResponseInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerWarnings
     */
    'detectedDpi'?: GetPaymentRequestEvidenceRecords200ResponseInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerWarnings
     */
    'calculatedDpi'?: GetPaymentRequestEvidenceRecords200ResponseInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerWarnings
     */
    'colorGradation'?: GetPaymentRequestEvidenceRecords200ResponseInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerWarnings
     */
    'heightMillis'?: GetPaymentRequestEvidenceRecords200ResponseInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidenceRecords200ResponseInnerWarnings
     */
    'widthMillis'?: GetPaymentRequestEvidenceRecords200ResponseInnerWarningsWidthMillisEnum;
}

export const GetPaymentRequestEvidenceRecords200ResponseInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidenceRecords200ResponseInnerWarningsDetectedDpiEnum = typeof GetPaymentRequestEvidenceRecords200ResponseInnerWarningsDetectedDpiEnum[keyof typeof GetPaymentRequestEvidenceRecords200ResponseInnerWarningsDetectedDpiEnum];
export const GetPaymentRequestEvidenceRecords200ResponseInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidenceRecords200ResponseInnerWarningsCalculatedDpiEnum = typeof GetPaymentRequestEvidenceRecords200ResponseInnerWarningsCalculatedDpiEnum[keyof typeof GetPaymentRequestEvidenceRecords200ResponseInnerWarningsCalculatedDpiEnum];
export const GetPaymentRequestEvidenceRecords200ResponseInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetPaymentRequestEvidenceRecords200ResponseInnerWarningsColorGradationEnum = typeof GetPaymentRequestEvidenceRecords200ResponseInnerWarningsColorGradationEnum[keyof typeof GetPaymentRequestEvidenceRecords200ResponseInnerWarningsColorGradationEnum];
export const GetPaymentRequestEvidenceRecords200ResponseInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestEvidenceRecords200ResponseInnerWarningsHeightMillisEnum = typeof GetPaymentRequestEvidenceRecords200ResponseInnerWarningsHeightMillisEnum[keyof typeof GetPaymentRequestEvidenceRecords200ResponseInnerWarningsHeightMillisEnum];
export const GetPaymentRequestEvidenceRecords200ResponseInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestEvidenceRecords200ResponseInnerWarningsWidthMillisEnum = typeof GetPaymentRequestEvidenceRecords200ResponseInnerWarningsWidthMillisEnum[keyof typeof GetPaymentRequestEvidenceRecords200ResponseInnerWarningsWidthMillisEnum];


